import Cookies from 'js-cookie';

export const baseUrls = JSON.parse(process.env.NEXT_PUBLIC_BASE || '{}');

export const demoTradingUrls = JSON.parse(process.env.NEXT_PUBLIC_DEMO || '{}');

const isDemoTrading = Cookies.get('Global-UserViewType') === 'demo-trading';

const apiConfig = isDemoTrading ? demoTradingUrls : baseUrls;

export const baseUrl = apiConfig.baseUrl;
export const gatewayUrl = apiConfig.gatewayUrl;
export const demoUrl = apiConfig.demoUrl;
export const navUrl = apiConfig.navUrl;

export default apiConfig;
export { isDemoTrading };
